import React from 'react'
import { Link } from 'react-router-dom'
import Icon from '../misc/Icons'
import {getRepoforId} from '../../utils/getRepoforId'


class SearchResultsFolderCard extends React.Component{

	render(){	

		const {folder} = this.props
		let linkPath=`/library/${folder.id}`
		let repoName = null
		let inSharedRepo = false
		if(folder.repo){
			const parentRepo = getRepoforId(folder.repo)
			if(parentRepo){
				repoName=parentRepo.name
				inSharedRepo=parentRepo.shared
			}
			linkPath=`/packs/${folder.repo}/${folder.id}`
		}


		return(
			<Link to={linkPath}>
				<div className='searchResultsCard searchResultsCard--folder'>					
					<Icon name={!folder.readOnly ? 'folder' : 'folder-isbe'}/>
					<div className='searchResultsCard-title'>
						{folder.name}
						{inSharedRepo && <Icon name='shared'/>}
						
						{repoName &&							
							<Link to={`/packs/${folder.repo}`} className='searchResultsCard--folder-repo'>
								{repoName}
							</Link>
						}
							

					</div>
					<div className='searchResultsCard-rightArrow'>
						<Icon name='chevron-right' />
					</div>
				</div>
			</Link>
		)
	}
}




export default SearchResultsFolderCard



// WEBPACK FOOTER //
// ./src/components/search/SearchResultsFolderCard.js